module.exports = __webpack_public_path__ + "img/lemon-left-1.a8c2795d.png";